var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stk-px-8"},[_c('NoteTaking',{attrs:{"meeting-id-query-param":_vm.meetingIdQueryParam}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }